import { applyMiddleware, createStore, compose } from 'redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { routerMiddleware } from 'react-router-redux';
import reduxPromise from 'redux-promise';
import thunk from 'redux-thunk';
import reducers from './reducers';

const LOCAL_STORAGE_KEY = 'redux_state';
const persistedState = localStorage.getItem(LOCAL_STORAGE_KEY);

const middleware = [
  routerMiddleware(Router),
  reduxPromise,
  thunk,
];

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  reducers,
  persistedState ? JSON.parse(persistedState) : {},
  composeEnhancers(
    applyMiddleware(...middleware),
  ),
);

store.subscribe(() => {
  // console.log('state.user');
  // TODO be selective
  const state = store.getState();
  // const token = state.user._token;
  const savedState = {
    user: state.user,
  };

  localStorage.setItem(
    LOCAL_STORAGE_KEY,
    JSON.stringify(savedState),
  );
  // localStorage.setItem(
  //   'token',
  //    token
  // );
});

export default store;
